import * as types from "./domain.types";
const initialState = {
	domain_active: "",
	domain_collection_list: [],
	domain_confirmation: null,
	domain_dns_record_list: [],
	domain_list: [],
	domain_relation: null,
	domain_relation_details: null,
	domain_tld_list: [],
};

export default function domain_reducer(state = initialState, action = null) {
	switch (action.type) {
		/* ---------------------------- SET ACTIVE DOMAIN --------------------------- */
		case types.DOMAIN_SET_ACTIVE:
			return {
				...state,
				domain_active: action.domain,
			};

		/* --------------------- DOMAIN COLLECTION LIST HANDLERS -------------------- */
		case types.DOMAIN_COLLECTION_LIST_CLEAR:
			return {
				...state,
				domain_collection_list: [],
			};

		case types.DOMAIN_COLLECTION_LIST_CLEAR_BY_TLD:
			return {
				...state,
				domain_collection_list: state.domain_collection_list.filter((v) => v.tld !== action.tld),
			};

		case types.DOMAIN_COLLECTION_LIST_CREATE:
			return {
				...state,
				domain_collection_list: [...state.domain_collection_list, action.domain_purchase_info],
			};

		case types.DOMAIN_COLLECTION_LIST_UPDATE:
			return {
				...state,
				domain_collection_list: state.domain_collection_list.map((v) =>
					v.sld === action.domain_purchase_info.sld && v.tld === action.domain_purchase_info.tld
						? action.domain_purchase_info
						: v,
				),
			};

		case types.DOMAIN_COLLECTION_LIST_DELETE:
			return {
				...state,
				domain_collection_list: state.domain_collection_list.filter(
					(v) =>
						v.sld !== action.domain_purchase_info.sld || v.tld !== action.domain_purchase_info.tld,
				),
			};

		/* -------------------------- DOMAIN LIST HANDLERS -------------------------- */
		case types.DOMAIN_LIST_ADD:
			return {
				...state,
				domain_list: [...state.domain_list, action.domain_purchase_info],
			};
		case types.DOMAIN_LIST_ADD_ASYNC: {
			const domainIsLoading =
				state.domain_list.filter((domain) => domain.tld === action.domain_purchase_info.tld)
					.length > 0;

			return {
				...state,
				domain_list: domainIsLoading
					? state.domain_list.map((domain) =>
							domain.tld === action.domain_purchase_info.tld
								? { ...action.domain_purchase_info, loading: false }
								: domain,
						)
					: [...state.domain_list, action.domain_purchase_info],
			};
		}

		case types.DOMAIN_LIST_CLEAR:
			return {
				...state,
				domain_list: initialState.domain_list,
			};
		case types.DOMAIN_LIST_DELETE:
			return {
				...state,
				domain_list: state.domain_list.filter((v) => v.tld !== action.tld),
			};

		case types.DOMAIN_LIST_LOADING:
			return {
				...state,
				domain_list: [
					...state.domain_list,
					{
						domain: action.domain,
						loading: true,
						tld: action.tld,
					},
				],
			};

		/* ----------------------------- DOMAIN RELATION ---------------------------- */
		case types.DOMAIN_RELATION_SET:
			return {
				...state,
				domain_relation: action.domain_relation,
			};
		case types.DOMAIN_RELATION_DETAILS_SET:
			return {
				...state,
				domain_relation_details: action.domain_relation_details,
			};

		/* ----------------------- DOMAIN REGISTER DNS RECORDS ---------------------- */
		case types.DOMAIN_DNS_RECORD_LIST_CREATE:
			return {
				...state,
				domain_dns_record_list: action.domain_dns_record_list,
			};
		case types.DOMAIN_DNS_RECORD_LIST_UPDATE:
			return {
				...state,
				domain_dns_record_list: action.domain_dns_record_list,
			};

		/* ------------------------ DOMAIN TLD LIST HANDLERS ------------------------ */
		case types.DOMAIN_TLD_LIST_ADD:
			return {
				...state,
				domain_tld_list: state.domain_tld_list.some((v) => v === action.tld)
					? state.domain_tld_list
					: [...state.domain_tld_list, action.tld],
			};

		case types.DOMAIN_TLD_LIST_ADD_ALL:
			return {
				...state,
				domain_tld_list: action.tld_list,
			};

		case types.DOMAIN_TLD_LIST_CLEAR:
			return {
				...state,
				domain_tld_list: initialState.domain_tld_list,
			};

		case types.DOMAIN_TLD_LIST_DELETE:
			return {
				...state,
				domain_tld_list: state.domain_tld_list.filter((v) => v !== action.tld),
			};

		/* ----------------------- DOMAIN CONFIRMATION HANDLER ---------------------- */
		case types.DOMAIN_CONFIRMATION_CREATE:
			return { ...state, domain_confirmation: action.payload };

		/* ---------------------------- DOMAIN RESET ALL ---------------------------- */
		case types.DOMAIN_RESET_ALL:
			return { ...initialState, domain_confirmation: state.domain_confirmation };

		default:
			return state;
	}
}
